export default __webpack_public_path__ + "static/media/benefits_img.188768c5.png";